import React, { memo } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import LinearProgress from '@mui/material/LinearProgress'
import Rating from '@mui/material/Rating'
import StarIcon from '@mui/icons-material/Star'
import useReviews from 'hooks/useReviews'
import sx from './styles'

const reviewsRow = [
  { stars: 5, value: 100 },
  { stars: 4, value: 15 },
  { stars: 3, value: 10 },
  { stars: 2, value: 5 },
  { stars: 1, value: 18 },
]

const GoogleRating = (props) => {
  const { title, description } = props
  const googleReviews = useReviews()
  const { formatMessage: f } = useIntl()

  const stars = (
    reviewsRow.map((review, index) => (
      <Grid
        key={`review-${index}`}
        sx={sx.ratingContainer}
      >
        <Box sx={sx.numberContainer}>
          <Typography
            variant="caption"
            sx={sx.number}
          >
            {review.stars}
          </Typography>
        </Box>
        <Box sx={sx.linearProgressContainer}>
          <LinearProgress
            color="secondary"
            variant="determinate"
            value={review.value}
            sx={sx.linearProgress}
            aria-label={`${review.value} ${f({ id: 'STARS' })}`}
          />
        </Box>
      </Grid>
    ))
  )
  return (
    <>
      <Box>
        {title && (
          <Typography
            variant="h4"
            sx={sx.title}
          >
            <FormattedMessage
              id={title}
              values={{ br: <br /> }}
            />
          </Typography>
        )}

        {description && (
          <Typography
            component="p"
            variant="caption"
            sx={sx.description}
            mb={2}
          >
            <FormattedMessage id={description} />
          </Typography>
        )}
      </Box>

      <Grid
        container
        alignItems="center"
      >
        <Grid size={8}>
          {stars}
        </Grid>
        <Grid
          size={4}
          textAlign="center"
        >
          <Box>
            <Typography
              component="p"
              variant="caption"
              sx={sx.average}
              align="center"
            >
              {googleReviews?.rating}
            </Typography>
          </Box>
          <Box mt={1}>
            <Rating
              sx={sx.rating}
              value={googleReviews?.rating ?? 0}
              readOnly
              precision={0.5}
              size="small"
              emptyIcon={(
                <StarIcon
                  style={{ opacity: 1 }}
                  fontSize="inherit"
                />
              )}
            />
          </Box>
          <Box>
            <Typography
              component="p"
              variant="caption"
              sx={sx.totalReviews}
            >
              <FormattedMessage
                id="TOTAL_REVIEWS"
                values={{ number: googleReviews?.user_ratings_total }}
              />
            </Typography>
          </Box>

        </Grid>
      </Grid>

    </>
  )
}

export default memo(GoogleRating)
